<template>
    <a-config-provider :autoInsertSpaceInButton="false" :locale="locale">
        <div class="sample-search">
            <div class="subtitle">控制样查询</div>

            <div class="search-input">
                <a-input-search placeholder="请输入" size="large" @search="onSearch">
                    <a-button slot="enterButton">查询</a-button>
                </a-input-search>
            </div>

            <div class="list-content">
                <div class="btns">
                    <a-button @click="generatePdf">确认生成PDF</a-button>
                </div>
                <a-table
                    :columns="columns"
                    :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                    :data-source="listData"
                    :loading="loading"
                    :scroll="{ x: 1500, y: 320 }"
                    :pagination="pagination"
                >
                    <template slot="action" slot-scope="text, record">
                        <a style="display: block" @click="toDetail(record.id)">详情</a>
                        <a style="display: block" @click="previewPdf(record)">预览PDF</a>
                        <a-upload
                            :multiple="false"
                            :showUploadList="false"
                            accept=".pdf"
                            :before-upload="beforeFileUpload"
                            :customRequest="handleFileChange"
                        >
                            <a style="display: block" @click="clickUpload(record.id)">上传</a>
                        </a-upload>
                    </template>
                </a-table>
            </div>

            <empty-result v-if="empty" />

            <result-card title="委托信息" v-if="empty">
                <template v-slot:tail>
                    <a>查看详情 ></a>
                </template>
            </result-card>
        </div>
    </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import emptyResult from '@/pages/query-service/components/empty-result.vue';
import resultCard from '@/pages/query-service/components/result-card.vue';
import { generatePDF, getSampleList, upload, updateSampleInfo } from '../../common/api';
import { uuid } from '../../common/utils';

export default {
    components: {
        emptyResult,
        resultCard
    },

    data() {
        return {
            selectedRowKeys: [],
            locale: zhCN,
            searching: false,
            loading: false,
            empty: false,
            searchKey: '',

            columns: [
                { title: '订购类型', dataIndex: 'sampletypename', key: 'sampletypename', ellipsis: true, width: 240 },
                { title: '订购单位名称', dataIndex: 'clientName', key: 'clientName', ellipsis: true },
                { title: '订购单位地址', dataIndex: 'clientAddress', key: 'clientAddress', ellipsis: true },
                { title: '联系人姓名', dataIndex: 'contactName', key: 'contactName', ellipsis: true },
                { title: '联系电话', dataIndex: 'contactPhone', key: 'contactPhone', ellipsis: true },
                { title: '邮编', dataIndex: 'zipCode', key: 'zipCode', ellipsis: true },
                { title: '传真', dataIndex: 'fax', key: 'fax', ellipsis: true },
                { title: '备注', dataIndex: 'remark', key: 'remark', ellipsis: true },
                {
                    title: '操作',
                    key: 'operation',
                    width: 100,
                    fixed: 'right',
                    scopedSlots: { customRender: 'action' }
                }
            ],
            currentId: '',

            listData: []
        };
    },

    computed: {
        pagination() {
            return {
                total: this.listData.length,
                showQuickJumper: true,
                showSizeChanger: true,
                showTotal(total) {
                    return `总共${total}条`;
                },

                defaultCurrent: 1
            };
        }
    },

    mounted() {
        this.getList();
        this.$emit('change', 'sampleSearch');
    },

    methods: {
        onSearch(val) {
            this.getList(val.trim());
        },

        async getList(searchKey = '') {
            this.loading = true;
            const params = { n: -1, qf: { clientName_CISC: searchKey } };
            const { data } = await getSampleList(params);
            this.listData = data.rows.map(t => {
                return {
                    key: t.id,
                    ...t,
                    ...t.ext$
                };
            });
            this.loading = false;
        },

        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
        },

        toDetail(id) {
            this.$router.push({ name: 'sampleDetail', query: { id } });
        },

        previewPdf(record) {
            if (!record?.initialPdfUrl) {
                return this.$message.error('请先进行确认并生成pdf文件！');
            }
            window.open(record.initialPdfUrl);
        },

        async generatePdf() {
            if (!this.selectedRowKeys.length) {
                return this.$message.warning('请选择一条数据');
            }
            if (this.selectedRowKeys.length > 1) {
                return this.$message.warning('只能选择单条数据');
            }

            const idArr = this.selectedRowKeys.map(t => ({ id: t }));
            const { data } = await generatePDF(idArr);
            if (data?.downloadUrl) {
                this.$message.success('生成pdf成功');
                this.getList();
            }
        },

        beforeFileUpload(file) {
            if (file.type !== 'application/pdf') {
                this.$message.error('只支持上传pdf类型文件!');
                return false;
            }
            return true;
        },

        clickUpload(id) {
            this.currentId = id;
        },

        async handleFileChange({ file }) {
            const { data } = await upload({
                name: file.name,
                file,
                targetId: `T_CSS_CONTROL_SAMPLE_ORDER_PDF$${uuid()}`
            });
            if (data) {
                await updateSampleInfo({ id: this.currentId, finalPdfId: data });
                await this.getList();
                this.$message.success('上传成功！');
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.sample-search {
    padding: 16px 24px;
    background: #ffffff;
    .subtitle {
        height: 48px;
        font-size: 24px;
        font-weight: 600;
        letter-spacing: 0;
        color: #005299;
        background: url(../../assets/test-service/split.png) bottom no-repeat;
    }
    .search-input {
        height: 80px;
        padding: 0 8px;
        display: flex;
        align-items: center;

        .ant-btn-lg {
            height: 48px;
            background: #005299;
            border: 1px solid rgba(0, 82, 153, 1);
            border-radius: 0px 4px 4px 0px;
            font-size: 18px;
            color: #ffffff;
            letter-spacing: 0;
            text-align: center;
            font-weight: 600;
            padding: 0 30px;
        }
    }
    .list-content {
        .btns {
            display: flex;
            justify-content: flex-start;
            .ant-btn {
                margin-right: 12px;

                &:hover,
                &:focus {
                    border-color: rgb(0, 82, 153);
                    color: #005bac;
                }
            }
        }
    }
}
</style>
